import { Controller } from "@hotwired/stimulus"
import Choices from 'choices.js'

export default class extends Controller {
  initialize() {
    var config = {
      noChoicesText: '選択されていません',
      removeItemButton: true,
      searchResultLimit: 10,
      placeholderValue: '検索ワード',
      searchPlaceholderValue: '検索ワード',
      noResultsText: '一致する情報は見つかりません',
      itemSelectText: '選択',
      shouldSort: false,
      //noChoicesText: '',
    }
    this.choices = new Choices(this.element, config)
  }
  connect() {

  }
}
